var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageDucUpload = function SvgImageDucUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.299 14.875H.12v-1H15.3v1ZM8.09.376a.5.5 0 0 0-.5.5v10.371a.5.5 0 1 0 1 0V.876a.5.5 0 0 0-.5-.5Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.76.5a.585.585 0 0 0 0 .751l3.035 3.458a.427.427 0 0 0 .66 0 .585.585 0 0 0 0-.752L8.419.5a.427.427 0 0 0-.66 0Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42.5a.427.427 0 0 0-.66 0L4.724 3.957a.585.585 0 0 0 0 .752.427.427 0 0 0 .66 0L8.42 1.25a.585.585 0 0 0 0-.751ZM15.678 9.19a.5.5 0 0 1 .5.5v5.186h-1V9.69a.5.5 0 0 1 .5-.5ZM.5 9.19a.5.5 0 0 1 .5.5v5.186H0V9.69a.5.5 0 0 1 .5-.5Z",
    fill: "#000"
  })));
};
export default SvgImageDucUpload;